import React, { useEffect} from 'react';
import {useDispatch} from 'react-redux';
import { useHistory } from 'react-router';
import DeleteModal from './DeleteModal';
import EditModal from './EditModal';
import FilterModal from './FilterModal';
import NewPassModal from './NewPassModal';
import './ConfirmationModal.css'
import {delete_observation_clean, validate_observation_clean} from '../redux/actions';
import PickAvatarModal from './PickAvatarModal';

function ConfirmationModal(props){
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if(props.tipo==='delete'){
            return () => dispatch(delete_observation_clean())
        }else if(props.tipo==='validar'){
            return () => dispatch(validate_observation_clean())
        }
       
    }, [])
    
    const innerModalStyles = {
        delete:'deletionModal',
        validar:'validationModal',
        filtrar: 'filterModal',
        novaPassword: 'newPassModal',
        editAvatar: 'editAvatarModal'

    }
   

    return(
        <div
        onClick = {() => history.goBack()}
        style={{position:'absolute', width:"100vw", height:"100vh", backgroundColor:'#00000099', zIndex:props.tipo==='delete'?20000:15000}}>
            <div className={innerModalStyles[props.tipo]} onClick={e=>e.stopPropagation()}>
                {props.tipo==='delete'?<DeleteModal />:null}
                {props.tipo==='validar'?<EditModal tipo='validar' />:null}
                {props.tipo==='filtrar'?<FilterModal />:null}
                {props.tipo==='novaPassword'?<NewPassModal />:null}
                {props.tipo==='editAvatar'?<PickAvatarModal />:null}
            </div>
        </div>
    )
    
}

export default ConfirmationModal